import { sortBy } from 'lodash';

import { PresentationTemplateSystemTemplateKind } from '@/types/schema';

// Order of the Luminary templates by expected usage volume.
const SYSTEM_TEMPLATE_KIND_ORDER: PresentationTemplateSystemTemplateKind[] = [
  PresentationTemplateSystemTemplateKind.Estate_360,
  PresentationTemplateSystemTemplateKind.EstateOverview,
  PresentationTemplateSystemTemplateKind.CurrentEstatePlanReview,
  PresentationTemplateSystemTemplateKind.DocumentReviewAndInventory,
  PresentationTemplateSystemTemplateKind.HypotheticalEstatePlanChanges,
  PresentationTemplateSystemTemplateKind.BeneficiaryOutcomes,
];

interface SortableSystemTemplate {
  displayName: string;
  systemTemplateKind?: PresentationTemplateSystemTemplateKind | null;
}

/** Sorts system templates by SYSTEM_TEMPLATE_KIND_ORDER; unknown kinds go last, alphabetically. */
export function sortSystemTemplates<T extends SortableSystemTemplate>(
  templates: T[]
): T[] {
  return sortBy(
    templates,
    (t) => {
      const idx = t.systemTemplateKind
        ? SYSTEM_TEMPLATE_KIND_ORDER.indexOf(t.systemTemplateKind)
        : -1;
      return idx === -1 ? SYSTEM_TEMPLATE_KIND_ORDER.length : idx;
    },
    'displayName'
  );
}
